import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { GalleryThemeDto } from '@nusign/picflow-backend-types';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { GalleryThemeService } from '../../../services/gallery-theme.service';
import { ToastService } from '../../../services/toast.service';
import { InputFieldComponent } from '../../../shared-extra/components/input-field/input-field.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-rename-custom-theme-dialog',
  templateUrl: './rename-custom-theme-dialog.component.html',
  styleUrl: './rename-custom-theme-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SvgComponent,
    ButtonDirective,
    LoadingIndicatorComponent,
    FormsModule,
    ReactiveFormsModule,
    InputFieldComponent,
  ],
})
export class RenameCustomThemeDialogComponent implements OnGetData {
  private galleryThemeService = inject(GalleryThemeService);
  private toasts = inject(ToastService);
  dialogName = 'rename-custom-theme';
  close: (...args) => void;
  theme: GalleryThemeDto;
  updating = signal(false);
  form = new FormGroup({ name: new FormControl('', [Validators.required]) });

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40 };
  }

  onGetData(data: { theme: GalleryThemeDto }, close: (...args) => void) {
    this.theme = data.theme;
    this.form.patchValue({ name: this.theme.name });
    this.close = close;
  }

  confirm() {
    if (this.updating()) return;
    if (!this.form.valid) return;
    this.updating.set(true);
    this.galleryThemeService.updateCustomTheme(this.theme.id, { name: this.form.value.name }).subscribe(() => {
      this.toasts.add('Theme updated', 'success');
    });
    this.close(true);
  }
}
